import api from '@/utils/api'
import TYPES from '@/store/types'
import axios, { AxiosPromise } from 'axios'

const actions = {
  /* 一键禁用账号 */
  [TYPES.POST_FORBIDDEN_MIS] ({ state, commit }, params: any): AxiosPromise<any> {
    return api.get('/account/stopMyAccount', {params})
  },

}

export default actions
